(function($){

    var restoreMaps = Cookies.get('input-landingstrip');

	console.log("restore Maps?", restoreMaps);
	console.log(typeof(restoreMaps));

	// Add Loaded Class
	$('.ptx-landingstrip').addClass('ptx-landingstrip--loaded');
	// Add compact class
	// alert("restoreMaps? " + restoreMaps);
	
	if(restoreMaps == "false"){
		$('.ptx-landingstrip').addClass('ptx-landingstrip--compact');
		console.log("HIDE SHIT");
	}
	

	// Add Required Class
	// $('.ptx-landingstrip').addClass('ptx-landingstrip--required');
  
	//.ptx-coursenav button

	$keyButtonGroup = ".ptx-landingstrip__toggle button, .ptx-landingstrip__biglink button, .ptx-landingstrip__closebutton button";

	$( $keyButtonGroup ).on( "click", function() {
		var isActive = $('.ptx-landingstrip').hasClass('ptx-landingstrip--compact');
		Cookies.set('input-landingstrip', isActive);
		console.log('active was', isActive);
		$('.ptx-landingstrip').toggleClass('ptx-landingstrip--compact', !isActive);
	});


	
})(jQuery);